'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'hat-wizard';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f6e8';
var svgPathData = ['M90.4 464l333.7 0-82.2-246.6c-4.9-14.8-5.8-30.5-2.7-45.8l17.2-82.8-95.6 49.3c-30.4 15.7-54.3 41.7-67.2 73.4L90.4 464zM160 368c0-6.9 4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5-13.5 40.4C253 443.6 246.9 448 240 448s-13-4.4-15.2-10.9l-13.5-40.4-40.4-13.5C164.4 381 160 374.9 160 368zm72-160c0-3.4 2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5s6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6z', 'M24 512l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-13.3 0-87.3-261.8c-2.2-6.7-2.7-13.9-1.2-20.8L413.7 49.3c4.1-19.8-16.6-35.5-34.5-26.2L238.9 95.6c-40.6 20.9-72.4 55.7-89.6 97.9L38.5 464 24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24zM341.9 217.4L424.1 464 90.4 464 193.6 211.6c13-31.7 36.8-57.7 67.2-73.4l95.6-49.3-17.2 82.8c-3.2 15.2-2.3 31 2.7 45.8zM240 288c-6.9 0-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C164.4 355 160 361.1 160 368s4.4 13 10.9 15.2l40.4 13.5 13.5 40.4c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l13.5-40.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C253 292.4 246.9 288 240 288zm32-120c-3.4 0-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2c-1.1-3.3-4.1-5.5-7.6-5.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHatWizard = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;